<files-grid-item
        *ngFor="let entry of entries; trackBy: trackById"
        [entry]="entry"
        [contextMenu]="{type: 'entry', entry: entry}"
        [folderDropTarget]="entry"
></files-grid-item>